import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { AppRatingFeedback } from '../types'

/**
 * save information about option user chooses when the user gives feedback
 * note - feedback tracks the number of times user has clicked on a specific feedback option.
 */
export const saveAppRatingFeedbackValue = async (
  userId: number | undefined,
  data: AppRatingFeedback,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  if (userId === undefined) {
    return new ApiResult<boolean, Error | AuthFetchError>(null, true)
  }

  try {
    const response = await authFetch<string>({
      path: `users/${userId}/rating-feedbacks`,
      method: 'POST',
      payload: { feedback: data },
    })

    if (response.status === StatusCodes.CREATED) {
      return new ApiResult<boolean, Error | AuthFetchError>(true)
    }

    return new ApiResult<boolean, Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
